import { ProductMetadata } from 'indices-list'
import { InvestStateStatus } from '../../storage/invest-states'
import { RetryStyledButton, StyledButton } from '../../styles'
import { getButtonText } from '../../utils'
import { Loader } from 'components/loader-css'

export const BuyButton: React.FC<{
  isDisabled: boolean
  isTransactionInPending: boolean
  isRetry: boolean
  productMetadata: ProductMetadata
  investState: InvestStateStatus
  isProcessing: boolean
  handleClick: () => void
}> = ({ investState, isDisabled, handleClick, isTransactionInPending, isRetry, isProcessing }) => {
  const text = getButtonText(investState, isTransactionInPending, isProcessing)

  return !isTransactionInPending && isRetry ? (
    <RetryStyledButton
      icon={isTransactionInPending || isProcessing ? <Loader /> : undefined}
      onClick={handleClick}
      disabled={isDisabled}
      buttonType="primary"
    >
      {text}
    </RetryStyledButton>
  ) : (
    <StyledButton
      icon={isTransactionInPending || isProcessing ? <Loader /> : undefined}
      onClick={handleClick}
      disabled={isDisabled}
      buttonType="primary"
    >
      {text}
    </StyledButton>
  )
}
